export const MerchantSelectionConfirmDialogViewUat = {
  title: 'merchantSelection.ConfirmDialog.title',
  description: 'merchantSelection.ConfirmDialog.description',
  confirmButton: 'merchantSelection.ConfirmDialog.confirmButton',
  cancelButton: 'merchantSelection.ConfirmDialog.cancelButton',
  addressLink: 'merchantSelection.ConfirmDialog.addressLink',
}
